module.exports = "pegasus/assets/blocks/column-lp18-basic.png";